import React, { forwardRef } from 'react';
import Icon from '@starbucks-web/pattern-library/lib/components/icon';

const StepperIconButton = forwardRef(
  ({ ariaDescribedBy, ariaLabel, ariaLabelledBy, onClick, path }, ref) => (
    <button
      aria-describedby={ariaDescribedBy}
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledBy}
      className="color-greenAccent"
      onClick={onClick}
      ref={ref}
    >
      <Icon path={path} size="24px" />
    </button>
  )
);

export default StepperIconButton;
